import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BarChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseRequestsStatusPayload } from '../payloads/requestsStatusPayload';
import { InsightChartFactory, InsightBuilderOptions } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
import { foldCompletedIntoApproved } from '../utils/foldCompletedIntoApproved';
import intl from 'react-intl-universal';

export const buildRequestsStatusInsightFactory = (
  payload: BaseInsightPayload,
  options?: InsightBuilderOptions
): InsightChartFactory => {
  const parsedPayload = parseRequestsStatusPayload(payload);
  const { data } = parsedPayload.data.attributes;
  const chartRows = options?.isCompletedStatusEnabled
    ? data
    : foldCompletedIntoApproved(data);

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.V_BAR)
      .setProps({
        chartData: chartRows as BarChartData,
        onDrillDown: props.onDrillDown,
        xAxisFieldName: 'request_status',
        yAxisFieldNames: ['request_count'],
        legendNames: [intl.get('INSIGHT.LEGEND.REQUEST_COUNT')],
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
      trendData: {
        value:
          parsedPayload.data.attributes.aggregate.total_requests.current ?? 0,
        trend:
          parsedPayload.data.attributes.aggregate.total_requests
            .percentage_change ?? 0,
        trendIsPercent: true,
        description: props.name,
      },
    });
  };
};
